module.exports = __webpack_public_path__ + "c502e3a8728892a3efd6577e39570c60.png";